import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, switchMap, throwError } from 'rxjs';
import { isSkippedByAuthInterceptorContext } from '@web/common';
import { AuthorizationHeaderService } from '../http/services/authorization-header.service';

export const AuthTokenInterceptor: HttpInterceptorFn = (request, next) => {
  const requestHeader = inject(AuthorizationHeaderService);

  if (isSkippedByAuthInterceptorContext(request)) {
    return next(request);
  }

  return requestHeader.appendAuthorizationHeader(request).pipe(
    switchMap((request) => next(request)),
    catchError((error) => throwError(() => error)),
  );
};
